import { InstallPWA, Loader } from '../Widgets';
import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import ArthaGateway from 'service/ArthaGateway';
import { ActionCreators } from 'store/actionCreators';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRightToBracket } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';
import { RootState } from 'store/store';
import { app_version, clearCache } from 'service/Utils';

export const Login = () => {
    const user = useSelector((state: RootState) => state.appdata);
    const [loginMode, setLoginmode] = useState<string>("user_name");
    const [tripCode, setTripCode] = useState<string>("");
    const [username, setUsername] = useState<string>("");
    const [password, setPassword] = useState<string>("");
    const [showAlert, setShowAlert] = useState<boolean>(false);
    const [isValidating, setIsValidating] = useState<boolean>(false);
    const dispatch = useDispatch();
    const userNameRef = useRef<HTMLInputElement | null>(null);
    const tripCodeRef = useRef<HTMLInputElement | null>(null);

    useEffect(() => {
        setUsername("");
        setPassword("");
        setTripCode("");
        if (loginMode == "trip_code") {
            if(tripCodeRef.current) {
                tripCodeRef.current.focus();
            }
        } else  {
            if(userNameRef.current) {
                userNameRef.current.focus();
            }
        } 
    }, [loginMode]);

    const validateLogin = () => {
        setIsValidating(true);
        ArthaGateway
            .validateLogin(username, password)
            .then((data) => {
                const user = {
                    userName: data.name,
                    name: data.name,
                    profile: data
                };
                sessionStorage.removeItem("production_plants");
                localStorage.setItem("login_time", moment().format());
                dispatch(ActionCreators.login(user));
                setIsValidating(false);
                setTimeout(() => window.location.href = "/", 500);
            })
            .catch(error => {
                console.log(error);
                setShowAlert(true);
                setUsername("");
                setPassword("");
                setTimeout(() => setShowAlert(false), 10000);
                setIsValidating(false);
            });
    };

    const validateTrip = () => {
        setIsValidating(true);
        ArthaGateway
            .getTripByCode(tripCode)
            .then((data) => {
                console.log("Trip data: ", data);
                const trip = data;
                localStorage.setItem("login_time", moment().format());
                dispatch(ActionCreators.trip_login(trip));
                setIsValidating(false);
                setTimeout(() => window.location.href = "/", 500);
            })
            .catch(error => {
                console.log(error);
                setShowAlert(true);
                setUsername("");
                setPassword("");
                setTripCode("");
                setTimeout(() => setShowAlert(false), 10000);
                setIsValidating(false);
            });
    }

    return (
        <form>
            <InstallPWA />
            <div className='login-form'>
                <div className='container'>
                    {showAlert &&
                        <div className="alert alert-danger" role="alert" style={{ marginBottom: 20 }}>
                            The username or password you entered is incorrect. Please try again.
                        </div>
                    }
                    {loginMode == "user_name" &&
                        <>
                            <div className="form-outline mb-4">
                                <label className="form-label">Username</label>
                                <input type="text" className="form-control" ref={userNameRef} value={username} onChange={(e) => setUsername(e.target.value)} />
                            </div>
                            <div className="form-outline mb-4">
                                <label className="form-label" >Password</label>
                                <input type="password" className="form-control" value={password} onChange={(e) => setPassword(e.target.value)} />
                            </div>
                            {(password.length > 4) &&
                                <div className="form-outline mb-4" style={{ width: "100%" }}>
                                    <div className='btn btn-dark w-100' onClick={validateLogin}>
                                        {isValidating &&
                                            <div className="spinner-border text-light" role="status">
                                                <span className="sr-only">Loading...</span>
                                            </div>
                                        }
                                        {!isValidating &&
                                            <>
                                                <FontAwesomeIcon icon={faRightToBracket} style={{ marginRight: 10 }} />
                                                Login
                                            </>
                                        }
                                    </div>
                                </div>
                            }
                            {/*<div style={{ width: "100%", textAlign: "center" }}>
                                <a href="#" onClick={(e) => setLoginmode("trip_code")} >Login using trip code</a>
                            </div>*/}
                        </>
                    }
                    {loginMode == "trip_code" &&
                        <>
                            <div className="form-outline mb-4">
                                <label className="form-label">Tripcode</label>
                                <input type="text" className="form-control" ref={tripCodeRef} value={tripCode} onChange={(e) => setTripCode(e.target.value)} />
                            </div>
                            {(tripCode.length > 1) &&
                                <div className="form-outline mb-4" style={{ width: "100%" }}>
                                    <div className='btn btn-dark w-100' onClick={validateTrip}>
                                        {isValidating &&
                                            <div className="spinner-border text-light" role="status">
                                                <span className="sr-only">Loading...</span>
                                            </div>
                                        }
                                        {!isValidating &&
                                            <>
                                                <FontAwesomeIcon icon={faRightToBracket} style={{ marginRight: 10 }} />
                                                Login
                                            </>
                                        }
                                    </div>
                                </div>
                            }
                            <div style={{ width: "100%", textAlign: "center" }}>
                                <a href="#" onClick={(e) => setLoginmode("user_name")} >Login using user name & password</a>
                            </div>
                        </>
                    }
                    <div className='version-number'>
                        <div className="btn btn-sm bg-dark" style={{ marginLeft: 20, marginBottom: 10, color: "#fff" }} onClick={clearCache}>Update to latest version</div>
                        <span style={{ marginRight: 20, float: "right" }} >{app_version}</span>
                    </div>
                </div>
            </div>
        </form>
    );
};